module.exports = __webpack_public_path__ + "img/placeholder-landscape-notext.19990d9a.png";